import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";
import db from "../Data/Database";

Vue.use(Vuex);

// Check if Browser Supports HTML5 Date type
let dateSupported = () => {
    var input = document.createElement('input');
    input.setAttribute('type', 'date');
    return (input.type !== "text");
};


const Server = process.env.VUE_APP_HOST_SERVER || "https://server.nbl1.basketball"

let Testing = (Server === "https://server.nbl1.basketball") ? false : true;

export default new Vuex.Store({
    state: {
        user: null,
        accessCode: null,
        userDetails: null,
    },
    mutations: {
        SET_USER_DATA(state, userData) {
            state.user = userData;
            db.currentState.update(1, {
                User: userData
            });
        },
        SET_ACCESS_CODE(state, code) {
            state.accessCode = code;
        },
        SET_USERDETAIL_DATA(state, detailData) {
            state.userDetails = detailData;
            db.currentState.update(1, {
                UserDetails: detailData
            });
        },
        CLEAR_USER_DATA(state) {
            state.user = null;
            db.currentState.update(1, {
                User: null
            });
        },
        CLEAR_ACCESS_CODE(state) {
            state.accessCode = null;
        },
        CLEAR_USERDETAIL_DATA(state) {
            state.userDetails = null;
            db.currentState.update(1, {
                UserDetails: null
            });
        },
    },
    actions: {
        reset({ commit }, credentials) {
            return axios
                .post(
                    `${Server}/auth/OUG_Reset_Credentials`,
                    // "https://server.nbl1.basketball/auth/OUG_Reset_Credentials",
                    credentials
                )
                .then(({ data }) => {
                    commit("CLEAR_USER_DATA", data);
                });
        },
        login({ commit }, credentials) {
            return axios
                .post(
                    `${Server}/auth/OUG_Login`,
                    // "https://server.nbl1.basketball/auth/OUG_login",
                    credentials
                )
                .then(({ data }) => {
                    commit("SET_USER_DATA", data.data);
                });
        },
        lookupuser({ commit }, Contact) {
            return axios
                .post(
                    `${Server}/portal/LookupUser`, // "https://server.nbl1.basketball/portal/LookupUser",
                    Contact
                )
                .then(({ data }) => {
                    if (data.AccessCode) {
                        commit("SET_USER_DATA", data.Contact);
                        commit("SET_ACCESS_CODE", data.AccessCode);
                        return data.Contact
                    } else {
                        // No record found
                        commit("CLEAR_USER_DATA");
                        commit("CLEAR_ACCESS_CODE");
                        commit("CLEAR_USERDETAIL_DATA");
                    }

                })
        },
        getContactDetails({ commit }, Contact_id) {
            return axios
                .post(
                    `${Server}/portal/getContactDetails`,
                    // "https://server.nbl1.basketball/portal/getContactDetails",
                    Contact_id
                )
                .then(({ data }) => {
                    if (data.Details.length > 0) {
                        commit("SET_USERDETAIL_DATA", data.Details);
                    } else {
                        commit("CLEAR_USERDETAIL_DATA");
                    }
                })
        },
    },
    getters: {
        loggedIn(state) {
            return !!state.user;
        },
        currentUser(state) {
            return state.user;
        },
        userDetails(state) {
            return state.userDetails;
        },
        currentAccess(state) {
            return state.accessCode
        },
        emergencyName(state) {
            let name = null
            if (state.userDetails) {
                name = state.userDetails.find((element) => {
                    return element.MasterDetail == 'Emergency Contact Person'
                })
            }
            name ? name = name.Description : name = null
            return name
        },
        emergencyPhone(state) {
            let phone = null
            if (state.userDetails) {
                phone = state.userDetails.find((element) => {
                    return element.MasterDetail == 'Emergency Contact Phone'
                })
            }
            phone ? phone = phone.Description : phone = null
            return phone
        },
        address(state) {
            let address = null
            if (state.userDetails) {
                address = state.userDetails.find((element) => {
                    return element.MasterDetail == 'Home Address'
                })
            }
            address ? address = address.Description : address = null
            return address
        },
        passport(state) {
            let passport = null
            if (state.userDetails) {
                passport = state.userDetails.find((element) => {
                    return element.MasterDetail == 'Season Contract & Compliance Documents' &&
                        (element.Description == 'Passport or proof of Citizenship')
                })
            }
            passport ? passport = true : passport = false
            return passport
        },
        integrity(state) {
            let integrity = null
            if (state.userDetails) {
                integrity = state.userDetails.find((element) => {
                    return element.MasterDetail == 'Season Contract & Compliance Documents' &&
                        element.Description == 'BA Integrity Gambling & Match Fixing Certificate'
                })
            }
            integrity ? integrity = true : integrity = false
            return integrity
        },
        coaching(state) {
            let coaching = null
            if (state.userDetails) {
                coaching = state.userDetails.find((element) => {
                    return element.MasterDetail == 'Season Contract & Compliance Documents' &&
                        element.Description == 'Coaching Course Certificate'
                })
            }
            coaching ? coaching = true : coaching = false
            return coaching
        },
        medical(state) {
            let coaching = null
            if (state.userDetails) {
                coaching = state.userDetails.find((element) => {
                    return element.MasterDetail == 'Season Contract & Compliance Documents' &&
                        element.Description == 'Medical Course Certificate'
                })
            }
            coaching ? coaching = true : coaching = false
            return coaching
        },
        birthCountry(state) {
            let country = null
            if (state.userDetails) {
                country = state.userDetails.find((element) => {
                    return element.MasterDetail == 'Country of Birth'
                })
            }
            country ? country = country.Description : country = null
            return country
        },
        PlayingStatus(state) {
            let status = null
            if (state.userDetails) {
                status = state.userDetails.find((element) => {
                    return element.MasterDetail == 'Playing Status'
                })
            }
            status ? status = status.Description : status = null
            return status
        },
        StaffStatus(state) {
            let status = null
            if (state.userDetails) {
                status = state.userDetails.find((element) => {
                    return element.MasterDetail == 'Staff Status'
                })
            }
            status ? status = status.Description : status = null
            return status
        },
        getdateMask() {
            return (dateSupported ? "####-##-##" : "##/##/####")
        },
        getdateFormat() {
            return (dateSupported ? "dd/mm/yyyy" : "yyyy-mm-dd")
        },

    },
});